export { ClientProfileSideBar } from './ClientProfileSideBar'



// WEBPACK FOOTER //
// ./components/easinsure/client-profile/side-bar/index.js